module.exports = __webpack_public_path__ + "static/media/BH-Dracula-Gold.607bc69c.png";